import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {ErrorPage, ThemeContext} from '../common';
import {fetchLeaderboard} from '../../actions/leaders';
import LeaderboardContent from '../Leaderboard/LeaderboardContent';
import {appId} from '../../store';
import {LIST_PAGE_SIZE} from '../../configs/constants';

class LeaderboardPanel extends Component {
  static propTypes = {
    isDisplayed: PropTypes.bool.isRequired,
    onLeaderboardToggle: PropTypes.func.isRequired,
    onFetchLeaderboard: PropTypes.func.isRequired,
    leaders: PropTypes.shape({
      hasMore: PropTypes.bool.isRequired,
      list: PropTypes.arrayOf(PropTypes.shape()).isRequired,
      currentPlayer: PropTypes.shape({
        points: PropTypes.number,
      }).isRequired,
    }).isRequired,
    error: PropTypes.shape({}).isRequired,
    application: PropTypes.shape({
      details: PropTypes.shape({
        leaderboard: PropTypes.bool,
      }),
    }).isRequired,
    onClose: PropTypes.func.isRequired,
  };

  onFetchPlayerForLeaderboard = (params) => {
    const {
      onFetchLeaderboard,
      leaders: {
        hasMore,
        isLeadersListFetching,
        page: currentPage,
      },
    } = this.props;
    const {resetPage = false} = params;
    const page = resetPage ? 1 : currentPage;
    if (!isLeadersListFetching && (resetPage || hasMore)) {
      onFetchLeaderboard({
        appId,
        page,
        size: LIST_PAGE_SIZE,
      });
    }
  };

  renderLeaderboard = (styles) => {
    const {
      application: {details: {leaderboard: isLeaderboardAvaible, id: gameId}},
      leaders: {isLeadersListFetchingError: {error}}, onClose,
    } = this.props;

    if (!gameId) {
      return null;
    }

    return (
      <div className="leaderboard-panel">
        <div className="leaderboard-panel__header" style={styles}>
          <h4>Leaderboard</h4>
          {
            onClose && <span className="icon icon-close" onClick={onClose}/>
          }
        </div>
        <div className="panel__content">
          {error || !isLeaderboardAvaible ?
            <ErrorPage message={error}/> :
            <LeaderboardContent
              onFetchPlayersForLeaderboard={this.onFetchPlayerForLeaderboard}
              {...this.props}
            />
          }
        </div>
      </div>
    );
  };

  render() {
    const {isDisplayed} = this.props;
    return (
      <ThemeContext.Consumer>
        {(theme) => {
          const styles = {backgroundColor: theme.primaryColor};

          return isDisplayed ? this.renderLeaderboard(styles) : <div/>;
        }}
      </ThemeContext.Consumer>
    );
  }
}

const mapStateToProps = ({
  application,
  leaders,
  error,
}) => ({
  application,
  leaders,
  error,
});

const bindActions = dispatch => (
  {
    onFetchLeaderboard: params => dispatch(fetchLeaderboard(params)),
    dispatch,
  }
);

export default connect(mapStateToProps, bindActions)(LeaderboardPanel);
